import React from 'react';
import { CaretDown } from '@phosphor-icons/react';

/**
 * @param {string} label - The text displayed above the select box
 * @param {Array} options - Array of objects { value: '...', label: '...' }
 * @param {string} name - The key used for form data
 * @param {boolean} required - Whether to show the asterisk
 */
const DropdownField = ({ label, options = [], name, id, required = false, value, onChange, placeholder = "Select an option" }) => {
  return (
    <div className="w-full font-body mb-6">
      <label 
        htmlFor={id || name} 
        className="block text-surface font-body text-base mb-2"
      >
        {label}{required && "*"}
      </label>
      
      <div className="relative">
        <select
          id={id || name}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className="w-full bg-white text-txt-main px-4 py-3 rounded-noq-sm 
                     border border-border-color focus:outline-none focus:ring-2 
                     focus:ring-background-dark transition-all duration-200 
                     appearance-none cursor-pointer text-base shadow-sm pr-12"
        >
          {/* Placeholder option */}
          <option value="" disabled hidden
          className='text-txt-sec text-base'>
            {placeholder}
          </option>
          
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {/* Custom Chevron Icon */}
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-txt-sec">
          <CaretDown size={20} weight="bold" />
        </div>
      </div>
    </div>
  );
};

export default DropdownField;